// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__14Pnu","checkboxCol":"Table_checkboxCol__jzZCy","emailCol":"Table_emailCol__GP-Xf","actionCol":"Table_actionCol__2D4gZ"};